<template>
  <div class="HomeTicker" :style="{ '--ticker-repeat': REPEAT }">
    <!--
      Accessibility: the text is repeated 16 times below for the animation only, so the
      animated track is hidden from screen readers (aria-hidden). This invisible copy
      (Bootstrap "visually-hidden") lets them announce the sentence once instead.
    -->
    <p class="visually-hidden">{{ text }}</p>
    <!-- Two identical groups: sliding the track by half its width loops without a visible jump -->
    <div class="HomeTicker_Track" aria-hidden="true">
      <div v-for="group in 2" :key="group" class="HomeTicker_Group">
        <span v-for="item in REPEAT" :key="item" class="HomeTicker_Item">
          <span class="HomeTicker_Text">{{ text }}</span>
          <img class="HomeTicker_Star" :src="starIconUrl" alt="" width="15" height="14" />
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import translations from '@/dictionaries/homepage.json';
import starIconUrl from '@/assets/img/icon-etoile-blanc.svg';

// Repetitions per group: enough for one group to stay wider than very large screens
const REPEAT = 8;

const text = translations.ticker.fr.text;
</script>

<style lang="scss" scoped src="./HomeTickerComponent.scss"></style>
